<template>
  <div class="ppt" v-loading="loading" :style="containerSize">
    <div v-if="loadError" class="ppt-error">{{ loadError }}</div>
    <swiper
      v-else
      ref="pptSwiper"
      :key="swiperKey"
      :options="mergedSwiperOption"
    >
      <swiper-slide
        v-for="(item, index) in carouselData"
        :key="item.id || 'slide-' + index"
      >
        <img :src="item.imgURL" draggable="false" alt="" />
      </swiper-slide>
      <div slot="button-prev" class="swiper-button-prev"></div>
      <div slot="button-next" class="swiper-button-next"></div>
    </swiper>
  </div>
</template>

<script>
import mixins from "@/utils/rem";
import { fetchSlidesList, resolveSlideImageUrl } from "@/api/pptSlides";
import { PPT_MODULES, isValidModuleCode } from "@/constants/pptModules";

export default {
  name: "PptSlideViewer",
  mixins: [mixins],
  props: {
    moduleCode: {
      type: String,
      required: true
    },
    /** 覆盖 constants 中的设计稿宽度 */
    designWidth: {
      type: Number,
      default: null
    },
    /** 覆盖 constants 中的设计稿高度 */
    designHeight: {
      type: Number,
      default: null
    },
    autoplay: {
      type: [Boolean, Object],
      default: false
    },
    loop: {
      type: Boolean,
      default: true
    },
    effect: {
      type: String,
      default: "coverflow"
    }
  },
  data() {
    return {
      loading: true,
      loadError: "",
      carouselData: [],
      swiperKey: 0
    };
  },
  computed: {
    mergedSwiperOption() {
      const canLoop = this.loop && this.carouselData.length > 1;
      return {
        autoplay: this.autoplay,
        loop: canLoop,
        effect: this.effect,
        allowTouchMove: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      };
    }
  },
  watch: {
    moduleCode: "reload",
    carouselData() {
      this.swiperKey += 1;
    }
  },
  created() {
    if (!isValidModuleCode(this.moduleCode)) {
      this.loadError = "无效的模块编码";
      this.loading = false;
      return;
    }
    const meta = PPT_MODULES[this.moduleCode];
    const dw = this.designWidth != null ? this.designWidth : meta.designWidth;
    const dh =
      this.designHeight != null ? this.designHeight : meta.designHeight;
    this.initRem(dw, dh);
    this.reload();
  },
  methods: {
    reload() {
      if (!isValidModuleCode(this.moduleCode)) {
        return;
      }
      this.loading = true;
      this.loadError = "";
      fetchSlidesList(this.moduleCode)
        .then(list => {
          const sorted = [...list].sort(
            (a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)
          );
          this.carouselData = sorted.map(s => ({
            id: s.id,
            imgURL: resolveSlideImageUrl(s.imageUrl)
          }));
          if (!this.carouselData.length) {
            this.loadError = "暂无幻灯片，请在运营后台上传图片";
          }
        })
        .catch(err => {
          let msg = "无法加载幻灯片，请检查接口或网络";
          if (err && err.response && err.response.data != null) {
            const d = err.response.data;
            if (typeof d === "string") {
              msg = d;
            } else if (d.message) {
              msg = d.message;
            } else if (d.Message) {
              msg = d.Message;
            }
          } else if (err && err.message) {
            msg = err.message;
          }
          this.loadError = msg;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.ppt {
  overflow: hidden;
  position: relative;
  min-height: 120px;
}

.ppt-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 200px;
  padding: 24px;
  font-size: 16px;
  color: #909399;
}

.ppt .swiper-container {
  width: 100%;
  height: 100%;
  .swiper-slide {
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 31px;
    height: 50px;
    margin-top: 0;
    transform: translateY(-50%);
  }
  .swiper-button-prev {
    padding: 300px 300px 300px 0;
    background-position: left center;
  }
  .swiper-button-next {
    padding: 300px 0 300px 300px;
    background-position: right center;
  }
}
</style>
